import ZoomMeeting from './container';

export default ZoomMeeting;



// WEBPACK FOOTER //
// ./src/components/ZoomMeeting/index.js